import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { LossPercentageDtoKey } from 'api/Clients/Types/LossPercentageDto'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const disclaimerLossPercentageColumns: GridColumn[] = [
  {
    title: 'Entity',
    field: LossPercentageDtoKey.company,
    cell: (props: GridCellProps) => {
      if (!props.dataItem?.tickmillCompany?.name) {
        return <td />
      }

      return <td>{props.dataItem.tickmillCompany.name}</td>
    },
    width: 180,
    show: true,
    filterable: true,
  },
  {
    title: 'Percentage',
    field: LossPercentageDtoKey.percentage,
    cell: (props: GridCellProps) => {
      if (!props.dataItem?.percentage) {
        return <td />
      }

      return <td>{props.dataItem.percentage}</td>
    },
    show: true,
    filterable: true,
  },
]
